<template>
  <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
    <div class="w-full flex justify-start items-start gap-[11px]">
      <!-- Product Tab Button -->
      <button
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          activeTab === 'product'
            ? 'border-b-2 border-[#2463EB] text-[#2463EB]'
            : 'text-[#96a0b5]',
        ]"
        @click="switchTab('product'), refreshCat"
        v-if="hasPermission('Product_View')"
      >
        Products
      </button>

      <!-- Category Tab Button -->
      <button
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          activeTab === 'category'
            ? 'border-b-2 border-[#2463EB] text-[#2463EB]'
            : 'text-[#96a0b5]',
        ]"
        @click="switchTab('category')"
        v-if="hasPermission('Product_Category_View')"
      >
        Product categories
      </button>

      <!-- unit tab button -->
      <button
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          activeTab === 'unit'
            ? 'border-b-2 border-[#2463EB] text-[#2463EB]'
            : 'text-[#96a0b5]',
        ]"
        @click="switchTab('unit')"
        v-if="hasPermission('Product_Unit_View')"
      >
        Product Unit
      </button>
    </div>

    <!-- product -->
    <div
      v-if="activeTab === 'product'"
      class="flex xs:flex-col lg:flex-row xs:justify-start lg:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 lg:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        List of all products
      </p>
      <div
        class="flex gap-1 md:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
      >
        <button
          @click="viewFilter"
          class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        >
          <span><img src="/assets/icon/sort.svg" alt=""/></span>
          Filters
        </button>
        <div class="dropdown">
          <button
            class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            v-if="
              hasPermission('Product_Create') ||
                hasPermission('Product_Category_Create')
            "
          >
            <i class="fa-solid fa-plus"></i> Create New
          </button>
          <ul
            class="dropdown-menu shadow-none"
            aria-labelledby="dropdownMenuButton"
          >
            <li
              v-if="hasPermission('Product_Create')"
              class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]"
              @click="viewAddMyProduct"
            >
              New Product
            </li>
            <li
              v-if="hasPermission('Product_Category_Create')"
              class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[12px] px-[16px]"
              @click="AddProductBundle"
            >
              New Product Bundle
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- category -->
    <div
      v-if="activeTab === 'category'"
      class="flex xs:flex-col lg:flex-row xs:justify-start lg:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 lg:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        List all Product categories created/on the system
      </p>
      <div
        class="flex gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
      >
        <button
          @click="categoryFilter"
          class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        >
          <span><img src="/assets/icon/sort.svg" alt=""/></span>
          Filter
        </button>
        <!-- <button
          v-if="hasPermission('Product_Unit_Create')"
          class="border-[1px] bg-[#7367F0] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        >
          <i class="fa-solid fa-plus"></i>
          New Product Unit
        </button> -->
        <button
          v-if="hasPermission('Product_Category_Create')"
          class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
          @click="addCategory"
        >
          <i class="fa-solid fa-plus"></i> New Product Category
        </button>
      </div>
    </div>

    <!-- unit -->
    <div
      v-if="activeTab === 'unit'"
      class="flex xs:flex-col lg:flex-row xs:justify-start lg:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 lg:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        List all Product units created/on the system
      </p>
      <div
        class="flex gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
      >
        <button
          @click="unitFilter"
          class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        >
          <span><img src="/assets/icon/sort.svg" alt=""/></span>
          Filter
        </button>
        <button
          @click="addUnit"
          v-if="hasPermission('Product_Unit_Create')"
          class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        >
          <i class="fa-solid fa-plus"></i> New Product Unit
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from "../../main";

export default {
  props: {
    activeTab: {
      type: String,
      default: "",
    },
    hasPermission: Function,
    viewFilter: Function,
    viewAddMyProduct: Function,
  },
  data() {
    return {
      showDropdown: null,
      isProductUploadModalVisible: false,
      isPriceUploadModalVisible: false,
    };
  },
  computed: {
    defaultTab() {
      if (this.hasPermission("Product_View")) {
        return "product";
      } else if (
        this.hasPermission("Product_Category_View") ||
        this.hasPermission("Product_Category_View")
      ) {
        return "category";
      }
      return "";
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.switchTab(this.defaultTab);
        }
      },
    },
  },

  methods: {
    refreshCat() {
      bus.$emit("refreshCat");
      bus.$emit("refreshUnit");
    },
    switchTab(tab) {
      if (this.activeTab !== tab) {
        this.$emit("tabSwitched", tab);
        if (tab === "product") {
          this.refreshCat();
        }
      }
    },
    AddProductBundle() {
      bus.$emit("viewAdds");
    },
    addCategory() {
      bus.$emit("viewAddCategory");
    },
    categoryFilter() {
      bus.$emit("FilterView");
    },
    addUnit() {
      bus.$emit("viewAddunit");
    },
    unitFilter() {
      bus.$emit("FilterViewUnit");
    },
  },
};
</script>
